import React from 'react';
import { Plus, X } from 'lucide-react';

interface Props {
  label: string;
  required?: boolean;
  items: string[];
  onChange: (items: string[]) => void;
  placeholder?: string;
  testId: string;
}

/** Editor di liste di punti (requisiti, benefit): una riga per voce con
 * rimozione singola e pulsante "+" per aggiungere una nuova voce. */
export function ListFieldEditor({ label, required, items, onChange, placeholder, testId }: Props) {
  const rows = items.length > 0 ? items : [''];

  const update = (i: number, v: string) => onChange(rows.map((r, idx) => (idx === i ? v : r)));
  const remove = (i: number) => onChange(rows.filter((_, idx) => idx !== i));
  const add = () => onChange([...rows, '']);

  return (
    <div data-testid={testId}>
      <label className="text-xs font-medium block mb-1.5">{label}{required && ' *'}</label>
      <div className="space-y-1.5">
        {rows.map((v, i) => (
          <div key={i} className="flex items-center gap-1.5">
            <input
              value={v}
              onChange={e => update(i, e.target.value)}
              onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); add(); } }}
              placeholder={placeholder}
              className="flex-1 h-9 px-3 rounded-lg border text-sm focus:outline-none focus:ring-2 focus:ring-[hsl(var(--dtk-focus))]"
              data-testid={`${testId}-input-${i}`}
            />
            <button
              type="button"
              onClick={() => remove(i)}
              disabled={rows.length === 1 && !v}
              title="Rimuovi voce"
              className="h-8 w-8 rounded-lg border flex items-center justify-center text-muted-foreground hover:bg-red-50 hover:text-red-600 disabled:opacity-40 transition-colors flex-shrink-0"
              data-testid={`${testId}-remove-${i}`}
            >
              <X className="w-3.5 h-3.5" />
            </button>
          </div>
        ))}
      </div>
      <button
        type="button"
        onClick={add}
        className="mt-2 h-8 px-3 rounded-lg border text-xs font-medium flex items-center gap-1.5 hover:bg-secondary/60 transition-colors"
        data-testid={`${testId}-add`}
      >
        <Plus className="w-3.5 h-3.5" /> Aggiungi voce
      </button>
    </div>
  );
}
